import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import get from 'lodash/get';
import moment from 'moment';
import Cleave from 'cleave.js/dist/cleave-react';
import * as analytics from '../../services/analytics';

const propTypes = {
  client: PropTypes.object,
  onNotifyError: PropTypes.func,
  onNotifySuccess: PropTypes.func,
  onSubmit: PropTypes.func,
  quote: PropTypes.object,
  updateQuote: PropTypes.func,
};

class Passport360EnrollmentDOBView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      dob: '',
      touched: false,
    };

    const quoteDob = get(props.quote, 'application.holders[0].dob');
    if (quoteDob) {
      this.state.dob = moment(quoteDob, 'YYYY-MM-DD').format('MM/DD/YYYY');
    }
  }

  componentDidMount() {
    analytics.page('Passport 360 - Enrollment DOB');
  }

  handleDobInit = (cleave) => {
    this.cleave = cleave;
    const quoteDob = get(this.props.quote, 'application.holders[0].dob');
    const defaultVal =
      (quoteDob && moment(quoteDob, 'YYYY-MM-DD').format('MM/DD/YYYY')) || null;
    cleave.setRawValue(defaultVal);
  };

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    analytics.track('Passport 360 - DOB Date Updated');
    const { quote, updateQuote, onNotifyError, onSubmit } = this.props;
    const holder = {
      ...get(quote, 'application.holders[0]'),
      dob: moment(this.state.dob, 'MM/DD/YYYY').format('YYYY-MM-DD'),
    };
    this.setState({
      isSubmitting: true,
    });
    updateQuote({
      ...quote,
      application: {
        ...quote.application,
        holders: [holder],
      },
    })
      .then(onSubmit)
      .catch((error) => {
        this.setState({
          isSubmitting: false,
        });
        onNotifyError(error);
      });
  };

  handleDateChange = (e) => {
    this.setState({
      dob: e.target.value,
    });
  };

  setTouched = () => {
    this.setState({
      touched: true,
    });
  };

  get title() {
    if (this.props.actor === 'broker') {
      const name = get(this.props.quote, 'application.holders[0].first_name');
      return `When is ${name}'s date of birth?`;
    } else {
      return 'When is your date of birth?';
    }
  }

  get isDateValid() {
    const isValidFormat = /\d{2}\/\d{2}\/\d{4}/.test(this.state.dob);
    const isValidDate = moment(this.state.dob, 'MM/DD/YYYY').isValid();
    return isValidFormat && isValidDate;
  }

  render() {
    const { isSubmitting } = this.state;

    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-7 p-t-30">
            <h3 className="text-center semi-bold">{this.title}</h3>

            <div className="Passport360EnrollmentDOBView-clientPhone card m-t-20">
              <div className="card-block form-group row">
                <label className="col-md-3 text-uppercase">
                  Policyholder birthdate
                </label>
                <div className="col-md-9">
                  <div className="form-group p-t-0 m-b-20">
                    <form onSubmit={this.handleSubmit}>
                      <div
                        className={classnames('form-group', {
                          'has-error': this.state.touched && !this.isDateValid,
                        })}
                      >
                        <label htmlFor="dob">Date of birth</label>
                        <div className="input-group date">
                          <span className="input-group-addon" id="basic-addon3">
                            <i className="fa fa-calendar-alt" />
                          </span>
                          <Cleave
                            id="dob"
                            className="form-control"
                            name="dob"
                            required
                            options={{
                              blocks: [2, 2, 4],
                              delimiter: '/',
                              numericOnly: true,
                            }}
                            placeholder="mm/dd/yyyy"
                            value={this.state.dob}
                            onChange={this.handleDateChange}
                            onBlur={this.setTouched}
                            onInit={this.handleDobInit}
                          />
                        </div>
                        {this.state.touched && !this.isDateValid && (
                          <span className="help-block">
                            Please enter a valid date MM/DD/YYYY
                          </span>
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <button
                className="btn btn-lg btn-complete"
                disabled={!this.isDateValid || isSubmitting}
                onClick={this.handleSubmit}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Passport360EnrollmentDOBView.propTypes = propTypes;

export default Passport360EnrollmentDOBView;
